class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }
  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }
  onSummaryClick(event) {
    event.preventDefault();
    // Modal open hoy ane click modal na area ma hoy (koi overlay summary par padto hoy) to close na karvu
    if (this.isOpen() && event.detail !== 0 && this.isClickInsideModal(event)) return;
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }
  // Click modal ni andar (blank space sahit) chhe ke nahi te check kare chhe
  isClickInsideModal(event) {
    const path = event.composedPath ? event.composedPath() : [];
    const content = this.detailsContainer.querySelector('.search-modal, .modal__content');

    // Element-based check (click thaya vakhate no path, etle remove/hide thayela element par pan sachu result)
    if (content && path.includes(content)) return true;

    // Position-based check: modal box ane search results panel na area ma click hoy to "inside" ganvu
    const panels = [content, ...this.querySelectorAll('[data-predictive-search], .default--search')];
    const x = event.clientX, y = event.clientY;
    return panels.some((el) => {
      if (!el) return false;
      const r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
    });
  }
  onBodyClick(event) {
    const path = event.composedPath ? event.composedPath() : [];
    // Search icon (summary) potano toggle pote handle kare chhe
    if (path.includes(this.summaryToggle) && !this.isClickInsideModal(event)) return;
    if (this.isClickInsideModal(event)) return;
    this.close(false);
  }
  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }
  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);

    setTimeout(() => {
      this.detailsContainer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('overflow-hidden');
    }, 300);
  }
}
customElements.define('details-modal', DetailsModal);